__turbopack_context__.v({
  "answer": "AskOurDataSection-module__1lnL9W__answer",
  "art": "AskOurDataSection-module__1lnL9W__art",
  "body": "AskOurDataSection-module__1lnL9W__body",
  "card": "AskOurDataSection-module__1lnL9W__card",
  "cohort": "AskOurDataSection-module__1lnL9W__cohort",
  "controlRow": "AskOurDataSection-module__1lnL9W__controlRow",
  "controls": "AskOurDataSection-module__1lnL9W__controls",
  "cover": "AskOurDataSection-module__1lnL9W__cover",
  "empty": "AskOurDataSection-module__1lnL9W__empty",
  "filterSlot": "AskOurDataSection-module__1lnL9W__filterSlot",
  "headerRow": "AskOurDataSection-module__1lnL9W__headerRow",
  "heading": "AskOurDataSection-module__1lnL9W__heading",
  "imageWrap": "AskOurDataSection-module__1lnL9W__imageWrap",
  "inner": "AskOurDataSection-module__1lnL9W__inner",
  "navBtn": "AskOurDataSection-module__1lnL9W__navBtn",
  "pill": "AskOurDataSection-module__1lnL9W__pill",
  "pillLabel": "AskOurDataSection-module__1lnL9W__pillLabel",
  "prov": "AskOurDataSection-module__1lnL9W__prov",
  "question": "AskOurDataSection-module__1lnL9W__question",
  "ref": "AskOurDataSection-module__1lnL9W__ref",
  "section": "AskOurDataSection-module__1lnL9W__section",
  "sep": "AskOurDataSection-module__1lnL9W__sep",
  "slide": "AskOurDataSection-module__1lnL9W__slide",
  "subline": "AskOurDataSection-module__1lnL9W__subline",
  "swatch": "AskOurDataSection-module__1lnL9W__swatch",
  "track": "AskOurDataSection-module__1lnL9W__track",
  "viewport": "AskOurDataSection-module__1lnL9W__viewport",
});
